/** The class strings long enough, or conditional enough, to be worth naming. */
export const BOOKS_QUESTION = {
  /**
   * Header and the three-way toggle pin together at the top of the card so a long group never
   * leaves the user looking at unlabelled rows. The negative margins bleed the background over
   * the card's 24px padding, which would otherwise leave transparent gutters that rows show
   * through, and the top corners are re-rounded to match the card because of it.
   */
  stickyTop:
    'sticky z-[3] -mx-6 -mt-6 flex w-[calc(100%+48px)] flex-col gap-3 rounded-t-3xl bg-neutral-0 px-6 pt-6',
  /** Separates the bar from the rows passing beneath it. A collapsed card has none, and the
   * gap would only widen its bottom padding past its top. */
  stickyTopOverRows: 'pb-3 shadow-[0_6px_12px_-6px_rgba(0,0,0,0.12)]',
  /** A real button, so `font` and `color` have to be taken back off the UA stylesheet. */
  cardHeader:
    'flex w-full cursor-pointer items-start gap-2 border-0 bg-transparent p-0 text-left [font:inherit] [color:inherit] disabled:cursor-default',
  merchantIcon: 'h-10 w-10 shrink-0 rounded-lg object-cover',
  outlinedIconBox:
    'flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-neutral-100 bg-neutral-0',
  /** Raw bank descriptors can be one unbroken token, so it wraps anywhere. Clamped on
   * mobile, where the amount stacks below it, but to two lines so the name stays readable. */
  merchantName: '[overflow-wrap:anywhere] max-sm:w-full max-sm:line-clamp-2',
  transactionRow:
    'flex w-full flex-col items-stretch border-b border-neutral-200 last:border-b-0',
  transactionRowMain:
    '@container flex w-full min-h-[52px] shrink-0 items-center max-sm:h-auto max-sm:flex-col max-sm:items-stretch max-sm:gap-4 max-sm:py-2',
  transactionAmount: 'w-[123px] shrink-0 p-2 text-right max-sm:w-auto',
  /**
   * Equal thirds squeeze a long label until its own padding collapses and the text touches
   * the border, so each toggle is floored at its content width.
   */
  rowToggle: 'min-w-fit flex-1 max-sm:w-full max-sm:flex-none',
  rowDetailToggle:
    'ml-1 flex h-6 w-6 cursor-pointer items-center justify-center border-none bg-transparent',
  /** The arbitrary descendant selector beats the Textarea atom's own min-height utility. */
  unsureNote:
    'flex w-full flex-col gap-2 px-2 pb-4 max-sm:[&_textarea]:min-h-[140px]',
  /** A tint, not a ring: a rounded outline per row broke the list into a stack of loose
   * cards, and adjacent rows needing an answer should read as one band. */
  rowNeedsAnswer: 'bg-danger-0',
} as const
